module.exports = __webpack_public_path__ + "static/img/404.4d790fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/layout/layout/error-page/404.png
// module id = 32Yq
// module chunks = 7